import { z } from 'my-zod'
import { damageWaiverCaseAdminView } from './damage-waiver-case-admin-view'

export const damageWaiverCaseBasicDetailAdminView = damageWaiverCaseAdminView.pick({
  shortId: true,
  subject: true,
  assignedTeam: true,
  lifecycleStatus: true,
  vehicleId: true,
  outfitterId: true,
  assignedUserId: true,
  riskSpecialistId: true,
  createdDate: true,
  lastModifiedDate: true
})

export type damageWaiverCaseBasicDetailAdminView = z.infer<typeof damageWaiverCaseBasicDetailAdminView>
